import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const labyrinthitis: AnswerPathTreeNode = {
  path: 'labyrinthitis',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredLabyrinthitisDetails }],
};
